import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { BiPlus, BiTrash } from "react-icons/bi";
import { HiOutlineEye } from "react-icons/hi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import configInfo from '../config/config.json';
import { formatDate } from '../utils/timeUtils';


const AlarmCategoryAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [alarmCategoryAttrs, setAlarmCategoryAttrs] = useState({
    id: '',
    code: '',
    description: '',
    notifTypeId: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [origAlarmCategoryAttrs, setOrigAlarmCategoryAttrs] = useState({});


  const escalLevelOptions = [
    { key: 1, value: 1 },
    { key: 2, value: 2 },
    { key: 3, value: 3 }
  ];

  const ageUnitOptions = [
    { key: 'm', value: 'm' },
    { key: 'h', value: 'h' },
    { key: 'd', value: 'd' }
  ];


  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg,              setErrMsg]              = useState('');
  const [errMsg_Update,       setErrMsg_Update]       = useState('');


  // Notif Type Stuff
  const [notifTypeList, setNotifTypeList] = useState([]);

/*
  const [notifTypeAddList, setNotifTypeAddList] = useState([]);

  const [unassignedNotifTypeList, setUnassignedNotifTypeList] = useState();

  const [showAddNotifTypeDialog, setShowAddNotifTypeDialog] = useState(false);
  const [addNotifTypeErrMsg, setAddNotifTypeErrMsg] = useState('');
*/


  // Escal Level Stuff
  const [escalLevelList, setEscalLevelList] = useState([]);

  const [escalLevelAttrs, setEscalLevelAttrs] = useState();
  const [escalLogic,      setEscalLogic]      = useState();

  const [showEscalLevelDialog, setShowEscalLevelDialog] = useState(false);
  const [escalDialogMode,      setEscalDialogMode]      = useState('VIEW');
  const [errMsg_LevelDialog,   setErrMsg_LevelDialog]   = useState('');


  // Escal Level Delete Stuff
  const [showEscalLevelDeleteDialog, setShowEscalLevelDeleteDialog] = useState(false);
  const [errMsg_EscalLevelDelete,    setErrMsg_EscalLevelDelete]    = useState('');


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setAlarmCategoryAttrs(props.objDetails);
      setOrigAlarmCategoryAttrs(props.objDetails);

      fetchNotifTypes();

      fetchEscalLevels(props.objDetails.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchNotifTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types?searchTerms=");

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data.data && res.data.data.length > 0)) {
          setNotifTypeList(res.data.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


/*
  const fetchAssociatedNotifTypes = (alarmCategoriesId) => {

    if (!alarmCategoriesId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-categories/" + alarmCategoriesId + "/notif-types");

        resolve(res.data);

        if (res.status === 200) {
          setNotifTypeList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }
*/

/*
  const fetchUnassignedNotifTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types");

        resolve(res.data);

        if (res.status === 200) {

          const cleanList = res.data;

          // Remove datapoint types already assigned to the user
          let tempList = [];

          for (let i=0; i<notifTypeList.length; i++) {
            tempList.push(notifTypeList[i].name);
          }

          let unassignedList = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!tempList.includes(cleanList[i].name)) {
              unassignedList.push(cleanList[i]);
            }
          }

          setUnassignedNotifTypeList(unassignedList);
        }

        setErrMsg(''); //### NEED TO FIX
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));  //### NEED TO FIX
      }
    });
  }
*/

  const fetchEscalLevels = (alarmCategoryId) => {

    if (!alarmCategoryId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-escal-levels?categoryId=" + alarmCategoryId);

        resolve(res.data);

        if (res.status === 200) {
          setEscalLevelList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setErrMsg_Update('');
    setEditMode(true);
  }

  const onAttrsInputChange = (e) => {
    setAlarmCategoryAttrs({ ...alarmCategoryAttrs, [e.target.name]: e.target.value })
  }

  const onNotifTypeClick = (key, event) => {

    // Deep copy, Make a deep copy
    let newAttr = JSON.parse (JSON.stringify(alarmCategoryAttrs));
    newAttr.notifTypeId = key;
    newAttr.notifType   = notifTypeList.find( item => item.id.toString() === key.toString()).name;

    setAlarmCategoryAttrs(newAttr);
  };


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setAlarmCategoryAttrs(origAlarmCategoryAttrs);

    setErrMsg_Update('');
    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!alarmCategoryAttrs.code || alarmCategoryAttrs.code.trim().length === 0) {
      setErrMsg_Update(t("I18N_ERR_Need_alarm_rule_code"));
    } else if (alarmCategoryAttrs.code.length > 50) {
      setErrMsg_Update(t("I18N_ERR_Max_len_code") + 50);
    } else if (alarmCategoryAttrs.code !== origAlarmCategoryAttrs.code) {
      validateCode();
    } else {
      validateOtherFields();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateCode() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-categories?code=" + alarmCategoryAttrs.code);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg_Update(t("I18N_ERR_Dup_alarm_cat_code"));
        } else {
          validateOtherFields();
        }

        return;
      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_Update(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (!alarmCategoryAttrs.description || alarmCategoryAttrs.description.trim().length === 0) {
      setErrMsg_Update(t("I18N_ERR_Need_description"));
    } else if (alarmCategoryAttrs.description.length > 200) {
      setErrMsg_Update(t("I18N_ERR_Max_len_desc") + 200);
    } else if (!alarmCategoryAttrs.notifTypeId || alarmCategoryAttrs.notifTypeId.length === 0) {
      if (configInfo.uiConfig.visibleFields.ALARMCAT_NotifType) {
        setErrMsg_Update(t("I18N_ERR_Need_notif_type"));
      } else {
        // If Notif Type not needed, fill in a dummy value
        setAlarmCategoryAttrs({ ...alarmCategoryAttrs, notifTypeId: 10000011 })
      }
    } else {
      setErrMsg_Update('');
      updateAlarmCategory();
    }
  }

  const updateAlarmCategory = () => {

    const reqBody = alarmCategoryAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("alarm-categories/" + alarmCategoryAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);
          fetchAlarmCat(alarmCategoryAttrs.id);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_Update(t(translateAPIError(error)));
        }
      }
    });

  }

  const fetchAlarmCat = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-categories/" + id);

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data && res.data.length > 0)) {
          setAlarmCategoryAttrs(res.data[0]);
          setOrigAlarmCategoryAttrs(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }



  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  // Notification related stuff

/*
  function handleNotifTypeInfo(notifType) {

    //setNotifTypeSelected(notifType);
    //setShowNotifTypeInfo(true);
  }

  const handleNotifTypeInfoClose = (e) => {
    //setNotifTypeSelected(null);
    //setShowNotifTypeInfo(false);
  }
*/


/*
  function handleAddNotifTypes() {
    fetchUnassignedNotifTypes();
    setShowAddNotifTypeDialog(true);
  }

  function handleAddNotifTypesClose() {
    setNotifTypeAddList([]);
    setShowAddNotifTypeDialog(false);
  }

  function handleAddNotifTypesSubmit() {
    let newNotifTypeList = [];

    if (notifTypeAddList.length === 0) {
      setShowAddNotifTypeDialog(false);
      return;
    }

    for (let i=0; i<notifTypeAddList.length; i++) {
      newNotifTypeList.push(notifTypeAddList[i]);
    }

    let reqBody = {
          notifTypeIds: newNotifTypeList
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("alarm-categories/" + alarmCategoryAttrs.id + "/notif-types", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setNotifTypeAddList([]);
          setAddNotifTypeErrMsg('');
          setShowAddNotifTypeDialog(false);
          //fetchAssociatedNotifTypes(alarmCategoryAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddNotifTypeErrMsg(t(translateAPIError(error)));
      }
    });
  }

  function handleRemoveNotifType(notifType) {

    let reqBody = {
          data: {
             notifTypeIds: []
          }
        };

    reqBody.data.notifTypeIds.push(notifType.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("alarm-categories/" + alarmCategoryAttrs.id + "/notif-types/", reqBody);

        resolve(res.data);
        if (res.status === 200) {
          setErrMsg('');
          //fetchAssociatedNotifTypes(alarmCategoryAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const handleNotifTypeSelect = (e) => {

    if (e.target.checked) {
      // Add notifType to the list
      notifTypeAddList.push(e.target.id);
    } else {
      const index = notifTypeAddList.indexOf(e.target.id);
      if (index > -1) {
        notifTypeAddList.splice(index, 1);
      }
    }

    setNotifTypeAddList(notifTypeAddList);
  }
*/


/*
  function renderNotifType(notifType, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{notifType.name}</td>
        <td>{notifType.description}</td>
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveNotifType(notifType)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }

  function renderAddNotifTypes(notifType, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td><Form.Check type="checkbox" id={notifType.id} label="" onChange={handleNotifTypeSelect} /></td>
        <td>{notifType.name}</td>
        <td>{notifType.description}</td>
      </tr>
    )
  }
*/


  // EscalLevel stuff

  const onAgeUnitSelect = (key, event) => {
    setEscalLogic({ ...escalLogic, ageUnit: key });
  };

  const onEscalLogicAttrsInputChange = (e) => {
    setEscalLogic({ ...escalLogic, [e.target.name]: e.target.value })
  }

  const onEscalLevelSelect = (key, event) => {
    setEscalLevelAttrs({ ...escalLevelAttrs, level: key });
  };

  const onEscalNotifTypeClick = (key, event) => {
    setEscalLevelAttrs({ ...escalLevelAttrs, notifTypeId: key })
  };

  const onEscalLevelAttrsInputChange = (e) => {
    setEscalLevelAttrs({ ...escalLevelAttrs, [e.target.name]: e.target.value })
  }

/*
  const onEscalLogicChange = (e) => {
    setEscalLogic(e.target.value);
  }
*/

  function handleAddEscalLevel() {
    setEscalDialogMode ('NEW');
    setEscalLevelAttrs({});
    setEscalLogic({});
    setShowEscalLevelDialog(true);
    setErrMsg('');
  }


  function handleAddEscalLevelSubmit() {

    if (!escalLevelAttrs.level || escalLevelAttrs.level.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_level"));
      return;
    } else if (!escalLevelAttrs.description || escalLevelAttrs.description.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_description"));
      return;
    } else if (escalLevelAttrs.description.length > 200) {
      setErrMsg_LevelDialog(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!escalLogic || escalLogic.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_escal_logic"));
      return;
    } else if (!escalLogic.age || escalLogic.age.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_age"));
      return;
    } else if (!isNaturalNumber(escalLogic.age)) {
      setErrMsg_LevelDialog(t("I18N_ERR_Validate_escal_age"));
      return;
    } else if (!escalLogic.ageUnit || escalLogic.ageUnit.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_age_time_unit"));
      return;
    } else if (!escalLevelAttrs.notifTypeId || escalLevelAttrs.notifTypeId.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_notif_type"));
      return;
    }

    let reqBody = escalLevelAttrs;
    reqBody.categoryId = alarmCategoryAttrs.id;

/*
    try {
      //JSON.parse(escalLogic);
      reqBody.escalLogic = JSON.parse(escalLogic);
    } catch (error) {
      setErrMsg_LevelDialog(t("I18N_ERR_Escal_level_logic_invalid_JSON"));
      return;
    }
*/
    // ##### Hard code type for now #####
    escalLogic.type = 'FAIL_TO_CLOSE';

    reqBody.escalLogic = escalLogic;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("alarm-escal-levels", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Restore UI to viewing mode
          setErrMsg_LevelDialog('');
          setEscalLevelAttrs(null);
          setEscalLogic(null);
          setShowEscalLevelDialog(false);
          fetchEscalLevels(alarmCategoryAttrs.id);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  function isNaturalNumber(str) {
    str = '' + str; // If input is a number, convert to string.
    const n = Math.floor(Number(str));
    return ((n !== Infinity) && (String(n) === str) && (n >= 0));
  }


  function handleViewEscalLevel(escalLevel) {

    setEscalLevelAttrs(escalLevel);
    //setEscalLogic(JSON.stringify(escalLevel.escalLogic, undefined, 4));
    setEscalLogic(escalLevel.escalLogic);

    setEscalDialogMode ('VIEW');
    setShowEscalLevelDialog(true);
  }

  function handleEditEscalLevel(escalLevel) {

    setEscalLevelAttrs(escalLevel);
    //setEscalLogic(JSON.stringify(escalLevel.escalLogic, undefined, 4));
    setEscalLogic(escalLevel.escalLogic);

    setEscalDialogMode ('EDIT');
    setErrMsg_LevelDialog('');
    setShowEscalLevelDialog(true);
  }

  function handleEscalLevelDialogClose() {
    setEscalLevelAttrs(null);
    setEscalLogic(null);
    setShowEscalLevelDialog(false);
    setShowEscalLevelDialog('');
  }

  function handleEscalLevelEditCancel() {
    setEscalLevelAttrs(null);
    setEscalLogic(null);
    setShowEscalLevelDialog(false);
    setErrMsg_LevelDialog('');
  }

  function handleEscalLevelEditSubmit() {

    if (!escalLevelAttrs.description || escalLevelAttrs.description.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_description"));
      return;
    } else if (escalLevelAttrs.description.length > 200) {
      setErrMsg_LevelDialog(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!escalLogic || escalLogic.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_escal_logic"));
      return;
    } else if (!escalLevelAttrs.notifTypeId || escalLevelAttrs.notifTypeId.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_notif_type"));
      return;
    } else if (!escalLevelAttrs.escalLogic || escalLevelAttrs.escalLogic.length === 0) {
      setErrMsg_LevelDialog(t("I18N_ERR_Need_age_time_unit"));
      return;
    } 

    let reqBody = escalLevelAttrs;

    // ##### Hard code type for now #####
    escalLogic.type = 'FAIL_TO_CLOSE';

    reqBody.escalLogic = escalLogic;
/*
    try {
      //JSON.parse(escalLogic);
      reqBody.escalLogic = JSON.parse(escalLogic);
    } catch (error) {
      setErrMsg_LevelDialog(t("I18N_ERR_Escal_level_logic_invalid_JSON"));
      return;
    }
*/

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("alarm-escal-levels/" + escalLevelAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEscalLevelAttrs(null);
          setEscalLogic(null);
          setErrMsg_LevelDialog('');
          setShowEscalLevelDialog(false);

          fetchEscalLevels(alarmCategoryAttrs.id);
        }
      } catch (error) {
        setErrMsg_LevelDialog(t(translateAPIError(error)));
      }
    });
  }


  // Related to NotifType delete

  function handleRemoveEscalLevel(escalLevel) {
    setEscalLevelAttrs(escalLevel);
    setShowEscalLevelDeleteDialog(true);
  }

  function handleEscalLevelDeleteCancel() {
    setEscalLevelAttrs(null);
    setEscalLogic(null);
    setErrMsg_EscalLevelDelete('');
    setShowEscalLevelDeleteDialog(false);
  }

  function handleEscalLevelDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("alarm-escal-levels/" + escalLevelAttrs.id);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg_EscalLevelDelete('');
          setShowEscalLevelDeleteDialog(false);
          fetchEscalLevels(alarmCategoryAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg_EscalLevelDelete(t(translateAPIError(error)));
        return;
      }
    });
  }


  function renderEscalLevel(escalLevel, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleEscalLevelInfo(escalLevel)}>{escalLevel.name}</span></td>
*/}
        <td style={{width:"10%"}}>{escalLevel.level}</td>
        <td style={{width:"30%"}}>{escalLevel.description}</td>
        <td style={{width:"51%"}}>{escalLevel.notifTypeName}</td>
        <td style={{width:"3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-loc" style={{fontSize:'11px'}}>{t("I18N_TIP_View_escal_level_info")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleViewEscalLevel(escalLevel)}><HiOutlineEye size={16} />
            </span>
          </OverlayTrigger>
        </td>
        <td style={{width:"3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-loc" style={{fontSize:'11px'}}>{t("I18N_TIP_Edit_escal_level")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleEditEscalLevel(escalLevel)}><PencilIcon size={16} />
            </span>
          </OverlayTrigger>
        </td>
        <td style={{width:"3%"}}>
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-loc" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_escal_level")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleRemoveEscalLevel(escalLevel)}><BiTrash size={16} />
            </span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_AlarmCategory_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_AlarmCategory_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_AlarmCategory_code")}: *</Col>
                  <Col>{t("I18N_Description")}: *</Col>
                  { configInfo.uiConfig.visibleFields.ALARMCAT_NotifType ?
                    <Col>{t("I18N_Notif_type")}: *</Col>
                  :
                    <Col></Col>
                  }
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code" value={alarmCategoryAttrs.code}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                              value={alarmCategoryAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  { configInfo.uiConfig.visibleFields.ALARMCAT_NotifType ?
                  <Col>
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!alarmCategoryAttrs.notifTypeId ? t("common:I18N_DROPDOWN_PROMPT") :
                           notifTypeList.find( item => item.id.toString() === alarmCategoryAttrs.notifTypeId.toString()).name}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {notifTypeList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onNotifTypeClick(item.id)}>
                              {item.id ? item.name : t("common:I18N_No_parent_menu")}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  :
                    <Col></Col>
                  }
                  <Col></Col>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg_Update}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>

              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_AlarmCategory_code")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                { configInfo.uiConfig.visibleFields.ALARMCAT_NotifType ?
                <Col>{t("I18N_Notif_type")}:</Col>
                : <Col></Col>
                }
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{minWidth:'60px', flexWrap: 'wrap', wordWrap: 'break-word'}}>{alarmCategoryAttrs.code}</Col>
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                            value={alarmCategoryAttrs.description} />
                </Col>
                { configInfo.uiConfig.visibleFields.ALARMCAT_NotifType ?
                <Col>{alarmCategoryAttrs.notifType}</Col>
                : <Col></Col>
                }
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{alarmCategoryAttrs.creatorUsername}</Col>
                <Col>{formatDate(alarmCategoryAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{alarmCategoryAttrs.updaterUsername}</Col>
                <Col>{formatDate(alarmCategoryAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }
        </div>


{/*
        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Associated_notif_types")}
            </span>
            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_notifType" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_notif_type")}</Tooltip>}>
                <span onClick={handleAddNotifTypes} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{fontWeight:'400'}}>{t("I18N_Notiftype_name")}</th>
                  <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(notifTypeList && notifTypeList.length > 0) ? notifTypeList.map(renderNotifType) : null}
              </tbody>
            </Table>
          </div>
        </div>
*/}


        {configInfo.uiConfig.visibleFields.ALARMCAT_EscalLevels ?
        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Escal_paths")}
            </span>
            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_notifType" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_escal_level")}</Tooltip>}>
                <span onClick={handleAddEscalLevel}
                      style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>    
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:"10%", fontWeight:'400'}}>{t("I18N_Level")}</th>
                  <th style={{width:"30%", fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th style={{width:"51%", fontWeight:'400'}}>{t("I18N_Notif_type")}</th>
                  <th style={{width:"3%"}}></th>
                  <th style={{width:"3%"}}></th>
                  <th style={{width:"3%"}}></th>
                </tr> 
              </thead>
              <tbody>
                {(escalLevelList && escalLevelList.length > 0) ? escalLevelList.map(renderEscalLevel) : null}
              </tbody>
            </Table>
          </div>
        </div>
        : null
        }

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft:'0px', fontSize:'12px', fontWeight:'300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', marginLeft: '20px' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>


{/*
        <Modal show={showAddNotifTypeDialog} onHide={handleAddNotifTypesClose} centered >
          <Modal.Body style={{height:'800px', overflow:'auto'}}>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Notiftypes")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th></th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Notiftype_name")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedNotifTypeList ? unassignedNotifTypeList.map(renderAddNotifTypes) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddNotifTypesClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddNotifTypesSubmit}>
                {t("I18N_Add_dpTypes")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {addNotifTypeErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>
*/}


        <Modal show={showEscalLevelDialog} onHide={handleEscalLevelDialogClose} centered >
          <Modal.Body>
            <div>
              <span>
                { (escalDialogMode === 'VIEW') ? t("I18N_Escal_level_info") :
                  (escalDialogMode === 'EDIT') ? t("I18N_Edit_escal_level") : t("I18N_New_escal_level")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            
              <Row className={classes.admin_pages__field_label}>
              { (escalDialogMode === 'VIEW') ?
                <Col>{t("I18N_Escal_level")}:</Col>
              :
                <Col>{t("I18N_Escal_level")}: *</Col>
              }
              </Row>
              <Row className={classes.admin_pages__field_value}>
              { (escalDialogMode === 'VIEW') ?
                <Col>{escalLevelAttrs ? escalLevelAttrs.level : ''}</Col>
              :
                <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={(!escalLevelAttrs || !escalLevelAttrs.level) ? t("common:I18N_DROPDOWN_PROMPT") : escalLevelAttrs.level}
                  onSelect={onEscalLevelSelect}>
                  {escalLevelOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                </Col>
              }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              { (escalDialogMode === 'VIEW') ?
                <Col>{t("I18N_Description")}:</Col>
              :
                <Col>{t("I18N_Description")}: *</Col>
              }
              </Row>
              <Row className={classes.admin_pages__field_value}>
              { (escalDialogMode === 'VIEW') ?
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                            value={escalLevelAttrs ? escalLevelAttrs.description : ''} />
                </Col>
              :
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                            value={escalLevelAttrs ? escalLevelAttrs.description : ''}
                            onChange={(e) => onEscalLevelAttrsInputChange(e)} />
                </Col>
              }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              { (escalDialogMode === 'VIEW') ?
                <Col>{t("I18N_Alarm_escal_logic")}:</Col>
              :
                <Col>{t("I18N_Alarm_escal_logic")}: *</Col>
              }
              </Row>

{/*
              <Row className={classes.admin_pages__field_value}>
              { (escalDialogMode === 'VIEW') ?
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="escalLogic"
                            value={escalLogic ? escalLogic : ''} />
                </Col>
              :
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="escalLogic"
                            value={escalLogic ? escalLogic : ''}
                            onChange={(e) => onEscalLogicChange(e)} />
                </Col>
              }
              </Row>
*/}
              <Row className={classes.admin_pages__field_value}>
              { (escalDialogMode === 'VIEW') ?
                <Col>
                  <span>{t("I18N_Alarm_unacked_for")}: </span>
                  <span>{escalLogic && escalLogic.age ? escalLogic.age : ''} </span>
                  <span>{escalLogic ? t("I18N_Time_unit_" + escalLogic.ageUnit) : ''}</span>
                </Col>
              :
                <Col>
                  <div style={{marginTop:'3px'}} className='input-group'>
                    <span>{t("I18N_Alarm_unacked_for")}:</span>
                    <span style={{marginLeft:'10px', maxWidth:'50px'}}>
                      <input style={{maxWidth:'50px'}} className={classes.admin_pages__field_editable} name="age"
                         value={escalLogic && escalLogic.age ? escalLogic.age : ''}
                         onChange={(e) => onEscalLogicAttrsInputChange(e)} />
                    </span>
                    <span style={{marginLeft:'10px'}}>
                      <DropdownButton style={{width:'100px'}} size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                        title={(!escalLogic || !escalLogic.ageUnit) ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_Time_unit_" + escalLogic.ageUnit)}
                        onSelect={onAgeUnitSelect}>
                        {ageUnitOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                              {t("I18N_Time_unit_" + item.value)}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </span>
                  </div>
                </Col>
              }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              { (escalDialogMode === 'VIEW') ?
                <Col>{t("I18N_Notif_type")}:</Col>
              :
                <Col>{t("I18N_Notif_type")}: *</Col>
              }
              </Row>
              <Row className={classes.admin_pages__field_value}>
              { (escalDialogMode === 'VIEW') ?
                <Col>{escalLevelAttrs ? escalLevelAttrs.notifTypeName : ''}</Col>
              :
                <Col>
{/*
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={(!escalLevelAttrs || !escalLevelAttrs.notifTypeId) ? t("common:I18N_DROPDOWN_PROMPT") :
                             notifTypeList.find( item => item.id.toString() === escalLevelAttrs.notifTypeId.toString()).name}
                             onSelect={onEscalNotifTypeSelect}>
                      {notifTypeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={item.id} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.id ? item.name : t("common:I18N_No_parent_menu")}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
*/}

                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {(!escalLevelAttrs || !escalLevelAttrs.notifTypeId) ? t("common:I18N_DROPDOWN_PROMPT") :
                           notifTypeList.find( item => item.id.toString() === escalLevelAttrs.notifTypeId.toString()).name}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {notifTypeList.map((item, index) => {
                          return (
                            <Dropdown.Item key={item.id} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onEscalNotifTypeClick(item.id)}>
                              {item.id ? item.name : t("common:I18N_No_parent_menu")}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                </Col>
              }
              </Row>

              { (escalDialogMode === 'VIEW') ?
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      onClick={handleEscalLevelDialogClose}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>
              :
                <>
                 <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                    <span>{t("I18N_Req_fields")}</span>
                 </Row>
                 <Row>
                   <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                     {errMsg_LevelDialog}
                   </span>
                 </Row>

                  <Row>
                    <div display='flex' style={{marginTop:'15px'}}>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ float: 'left' }}
                        onClick={handleEscalLevelEditCancel}>
                        {t("I18N_Cancel")}
                      </Button>
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        style={{ marginLeft: '15px' }}
                        onClick={escalDialogMode === 'EDIT' ? handleEscalLevelEditSubmit : handleAddEscalLevelSubmit}>
                        {t("I18N_Save")}
                      </Button>
                    </div>
                  </Row>
                  </>
                }
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showEscalLevelDeleteDialog} onHide={handleEscalLevelDeleteCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
              <div>
                {t("I18N_Escal_level_delete_confirm")}
              </div>
              <div style={{marginTop:'5px', fontStyle:'italic'}}>
                {escalLevelAttrs ? escalLevelAttrs.description : ''}
              </div>

              <form>
                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_EscalLevelDelete}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }}
                      onClick={handleEscalLevelDeleteCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft: '15px' }}
                      onClick={handleEscalLevelDeleteSubmit}>
                      {t("I18N_Yes")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>

      </Card>
    </>
  );
}
 
export default AlarmCategoryAdminDetailsView;
